<template>
  <li class="list">
    <router-link class="routerProfileLink" to="/profile">Profile</router-link>
  </li>
</template>

<style scoped>
.routerProfileLink {
  display: flex;
  align-items: center;

  font-size: 1.2rem;
  padding: 0 0.75em;
  height: 50px;
  font-weight: bold;
  transition: all 0.2s ease-in-out;
  border-width: 0px 3px 0px 3px;
  border-style: groove;
  border-color: #822e21;
}
.routerProfileLink:hover {
  background-color: #822e21;
  box-shadow: 0 5px 12px #822e21;
  border-radius: 0.25rem;
  color: black;
}
.list {
  transition: all 0.2s ease-in-out;
  margin: 0 10px;
}

@media (max-width: 1200px) {
  .list {
    display: none;
  }
}
</style>
<script>
export default {
  name: "navbar-profile-button",
};
</script>
